import { brDateFormat, settingAge } from "./date.helpers";
import { maskPhone } from "./mask.helpers";
import { formatGender } from "./text.helpers";
export function personalAddress(renter) {
  return [
    {
      id: 1,
      spanSize: "col-span-1",
      label: "CEP",
      value: renter.address.zipcode,
    },
    {
      id: 2,
      spanSize: "col-span-2",
      label: "Endereço",
      value: renter.address.street,
    },
    {
      id: 3,
      spanSize: "col-span-1",
      label: "Número",
      value: renter.address.number,
    },
    {
      id: 4,
      spanSize: "col-span-2",
      label: "Complemento",
      value: renter.address.complement,
    },
    {
      id: 5,
      spanSize: "col-span-1",
      label: "Estado",
      value: renter.address.state,
    },
    {
      id: 6,
      spanSize: "col-span-1",
      label: "Cidade",
      value: renter.address.city,
    },
    {
      id: 7,
      spanSize: "col-span-1",
      label: "Bairro",
      value: renter.address.district,
    },
  ];
}
export function getPersonalInfoList(renter) {
  const genderMap = {
    male: "male",
    female: "female",
    other: "other",
  };
  return [
    { label: "Nome", value: renter.name },
    { label: "E-mail", value: renter.email },
    { label: "WhatsApp", value: maskPhone(renter.whatsapp) },
    {
      label: "Gênero",
      value:
        formatGender(genderMap[renter.gender]) || formatGender(renter.gender),
    },
    { label: "Nome da mãe", value: renter.motherName },
    { label: "CPF da pessoa que o(a) indicou", value: renter.cpfDoIndicador },
    {
      label: `Data de nascimento (${settingAge(
        brDateFormat(renter.birthDate)
      )} anos)`,
      value: brDateFormat(renter.birthDate),
    },
    { label: "Estado civil", value: renter.maritalStatus },
    { label: "CPF", value: renter.cpf },
    { label: "Tipo sanguíneo", value: renter.typeSanguine },
    { label: "CNH", value: renter.cnh },
    {
      label: "Data de vencimento da CNH",
      value: brDateFormat(renter.cnhExpirationDate),
    },
    { label: "Categoria CNH", value: renter.categoryCNH },
    { label: "RG", value: renter.rg },
    { label: "Orgão expedidor", value: renter.rg_orgexp },
    { label: "Origem do Lead", value: renter.leadOrigin },
    { label: "Consultor", value: renter.technicalConsultant },
    { label: "Representante de vendas (SDR)", value: renter.sdr },
  ];
}
